import * as React from 'react';
import { ArrowIcon } from '../ArrowIcon';
import * as styles from './Button.css';

interface IButtonProps {
  direction: 'right' | 'left';
  onClick(): void;
}

export const Button = ({ direction, onClick }: IButtonProps) => {
  return (
    <div className={styles['wrapper']} onClick={onClick}>
      <ArrowIcon direction={direction} />
    </div>
  );
};
